import { Menu, Layout, theme, Button, Space, Modal } from "antd";
import { useThemeContext } from "../App";
import { getCurrentUser } from "aws-amplify/auth";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import { useGlobalContext } from "./GlobalContext";

//, "Course"
const navigators = ["Project", "Support"].map((key, index) => ({
  key,
  label: `${key}`,
  // disabled: index === 2 ? true : false,
}));

const GET_USER = gql`
  query MyQuery($id: uuid!) {
    user_by_pk(id: $id) {
      name
      email
      phone
    }
  }
`;

export default function MainHeader(props) {
  const { state } = useThemeContext();
  const [loginModal, setLoginModal] = useState(false);
  const navigate = useNavigate();
  const { userId, setUserId, setUserName } = useContext(useGlobalContext);

  const [currentPage, setCurrentPage] = useState([props.select]);
  const { error, data } = useQuery(GET_USER, {
    variables: { id: userId },
  });
  if (error) {
    console.log(error.message);
  }

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  useEffect(() => {
    if (data) {
      setUserName(data.user_by_pk.name);
    }
  }, [data, setUserName]);

  useEffect(() => {
    async function loginVerification() {
      try {
        const { userId } = await getCurrentUser();

        // console.log(`The userId: ${userId}`);
        setUserId(userId);
      } catch (err) {
        console.log(err);
        setLoginModal(true);
      }
    }
    loginVerification();
  }, [navigate, setLoginModal, setUserId]);

  useEffect(() => {
    setCurrentPage([props.select]);
  }, [props]);

  return (
    // <HeaderSelectionContext.Provider value={setCurrentPage}>
    <Layout style={{ height: "100%", overflow: "auto" }}>
      <Layout.Header
        style={{
          display: "flex",

          alignItems: "center",
          marginBottom: "2px",
          background: colorBgContainer,
        }}
      >
        <img
          src={
            state.name === "light" ? "/RfSonsLogo.png" : "/RfSonsLogoLight.png"
          }
          alt="Logo"
          onClick={() => {
            window.location = "/home";
          }}
          style={{ width: "128px", height: "40px", marginRight: "32px" }}
        />

        <Menu
          theme="light"
          items={navigators}
          defaultSelectedKeys={currentPage}
          selectedKeys={currentPage}
          onClick={({ key }) => {
            setCurrentPage([key]);
            if (key === "Project") navigate(`/project_list`);
            else if (key === "Support") navigate(`/support`);
          }}
          mode="horizontal"
          style={{
            borderBottom: "0px",
            display: "flex",
            justifyContent: "flex-end",
            width: "200",
          }}
        />
        <Space
          direction="horizontal"
          style={{ width: "100%", justifyContent: "right" }}
        >
          <Button
            type="text"
            onClick={() => {
              navigate("/user_details", { state: { id: userId } });
            }}
          >
            Hello! {data ? data.user_by_pk.name : ""}
          </Button>
        </Space>
      </Layout.Header>
      {props.children}
      <Modal
        title="Sign In Required"
        centered
        style={{ textAlign: "center" }}
        open={loginModal}
        onCancel={() => {
          Modal.destroyAll();
        }}
        footer={[
          <Button key="submit" type="primary" onClick={() => navigate("/")}>
            OK
          </Button>,
        ]}
      >
        <p>Please sign in your account</p>
      </Modal>
    </Layout>
    // {/* </HeaderSelectionContext.Provider> */}
  );
}
// export const useHeaderSelectionContext = () =>{
//   return useContext(HeaderSelectionContext);
// }
